import { render, staticRenderFns } from "./tablesView.vue?vue&type=template&id=27897b1c&scoped=true"
import script from "./tablesView.vue?vue&type=script&lang=js"
export * from "./tablesView.vue?vue&type=script&lang=js"
import style0 from "./tablesView.vue?vue&type=style&index=0&id=27897b1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27897b1c",
  null
  
)

export default component.exports